import React from 'react';
import { useSelector } from 'react-redux';

import {
  RECORDING_REQUEST_MODAL_STAGE,
  RecordingRequestStageSelector,
} from 'features/recording';
import RequestedLectureListModal from '../RequestedLectureListModal';
import RecordingRequestActionModal from '../RecordingRequestActionModal';

function RecordingRequestModalContentRenderer() {
  const modalStage = useSelector(RecordingRequestStageSelector);

  switch (modalStage) {
    case RECORDING_REQUEST_MODAL_STAGE.moduleDetailStage:
      return <RequestedLectureListModal />;
    case RECORDING_REQUEST_MODAL_STAGE.actionStage:
      return <RecordingRequestActionModal />;
    default:
      return null;
  }
}

export default RecordingRequestModalContentRenderer;
